import React from 'react';

export default function Tab({ label, icon, className, ...props }) {

	const allProps = {
		label,
		icon,
		className,
		...props
	};

	return (
		<div {...allProps} />
	);
}